import React from 'react';
import { problemSection } from '../data/content';
import { CtaButton } from './CtaButton';
export function ProblemSection() {
  const {
    title,
    intro,
    list,
    outro,
    highlight
  } = problemSection;
  return <section className="bg-slate-50 px-4 py-5 md:px-12 md:py-7" data-id="element-135" data-mp="30hhah9mrbvyo">
      <article className="rounded-md border border-slate-200 border-l-[5px] border-l-teal-700 bg-white px-4 py-3.5 md:px-5 md:py-4" data-id="element-136" data-mp="2vqhgac50vrzv">
        <h2 className="text-[19px] font-extrabold uppercase leading-[1.2] tracking-[-0.2px] text-blue-950 md:text-[24px]" data-id="element-137" data-mp="39h4cnxnb95ss">
          {title}
        </h2>
        <p className="mt-2 text-[14px] leading-[1.45] text-slate-600 md:text-[15px]" data-id="element-138" data-mp="35in5xf7sxxbw">{intro}</p>
        <ul className="mt-2 space-y-1 text-[14px] leading-[1.45] text-slate-600 md:text-[15px]" data-id="element-139" data-mp="3jdplku2gb11w">
          {list.map(item => <li key={item} className="flex gap-2" data-id="element-140" data-mp="1p1iwqsgmwlr4">
              <span className="mt-[0.55em] h-1.5 w-1.5 shrink-0 rounded-full bg-teal-700" aria-hidden data-id="element-141" data-mp="1p2atw7pvqrji" />
              <span data-id="element-142" data-mp="1k52ay4wwqjh7">{item}</span>
            </li>)}
        </ul>
        <p className="mt-2.5 text-[14px] font-bold leading-[1.45] text-blue-950 md:text-[15px]" data-id="element-143" data-mp="jeeomg1zv5eu">{outro}</p>
        <p className="mt-2 text-[13px] font-extrabold uppercase leading-tight text-teal-700 md:text-[15px]" data-id="element-144" data-mp="ocpz8t045jy4">
          {highlight}
        </p>
      </article>
      <div className="pt-4" data-id="element-145" data-mp="x51qgh31xbf5">
        <CtaButton mode="scroll" subtext="6 volúmenes + 5 bonos gratis — mirá el precio de lanzamiento" data-id="element-146" data-mp="x5biea7npsnh">
          Quiero ordenar mi trabajo clínico
        </CtaButton>
      </div>
    </section>;
}